import { SET_STEP } from '../constants/stepTypes';

const initialState = {
  currentStep: null,
  descriptKey: null,
  pathName: null,
};

export default function stepData(
  state = initialState,
  { type, step, descriptKey, pathName, section },
) {
  switch (type) {
    case SET_STEP:
      return {
        currentSection: section,
        currentStep: step,
        descriptKey,
        pathName,
      };
    default:
      return state;
  }
}
